module.exports = __webpack_public_path__ + "img/shenghuojiaofei.9c1d8c65.png";